import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { wtGetFromLocalStorage } from 'src/helpers/commons/LocalStorage';
import { currentDateTime, wtFormatDate } from 'src/helpers/commons/moment';
import { lzNotifyErrorMessageFromResult } from 'src/helpers/commons/notifications';
import { wtFormatMoney } from 'src/helpers/commons/utils';

const user = wtGetFromLocalStorage('authUser')

const Pdf = async (cashFlowStatementData, asOf, lastYearLastDate) => {

    const generatePdf = (cashFlowStatementData, asOf, lastYearLastDate) => {

        if (!cashFlowStatementData) {
            lzNotifyErrorMessageFromResult("No Data found!");
            return;
        }

        var doc = new jsPDF();
        var totalPagesExp = '{total_pages_count_string}';

        const logo = 'assets/wil-icon.png';

        const header = () => {
            var pageSize = doc.internal.pageSize;
            var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();

            doc.setFontSize(11);
            doc.setTextColor('#3c4b64');
            doc.setFont('Helvetica', 'bold');
            doc.addImage(logo, 'PNG', 5, 4, 25, 25);
            doc.line(32, 6, 32, 25);

            doc.text('WAH', 35, 10, { align: 'left' });
            doc.text('INDUSTRIES', 35, 15);
            doc.text('LIMITED', 35, 20);
            doc.setFontSize(9);
            doc.text('www.wahindustries.com', 35, 25);
            doc.setFontSize(11);
            doc.text("STATEMENT OF FINANCIAL POSITION", pageWidth - 85, 15, { align: 'left' });
            doc.text("AS OF " + wtFormatDate(asOf, "MMMM D, Y"), pageWidth - 85, 22, { align: 'left' });

            doc.line(10, 30, pageWidth - 10, 30);
        };


        const headerNotes = () => {
            var pageSize = doc.internal.pageSize;
            var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();

            doc.setFontSize(11);
            doc.setTextColor('#3c4b64');
            doc.setFont('Helvetica', 'bold');
            doc.addImage(logo, 'PNG', 5, 4, 25, 25);
            doc.line(32, 6, 32, 25);

            doc.text('WAH', 35, 10, { align: 'left' });
            doc.text('INDUSTRIES', 35, 15);
            doc.text('LIMITED', 35, 20);
            doc.setFontSize(9);
            doc.text('www.wahindustries.com', 35, 25);
            doc.setFontSize(11);
            doc.text("NOTES TO THE FINANCIAL POSITION", pageWidth - 88, 15, { align: 'left' });
            doc.text("AS OF " + wtFormatDate(asOf, "MMMM D, Y"), pageWidth - 88, 22, { align: 'left' });

            doc.line(10, 30, pageWidth - 10, 30);
        };

        const footer = () => {
            let pageNo = doc.internal.getNumberOfPages();
            var pageSize = doc.internal.pageSize;
            var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();

            doc.setFontSize(10)
            doc.text(
                "This report is printed through ERP at ",
                60,
                pageHeight - 15
            );


            doc.setTextColor('#0202f7')
            doc.setFont('Helvetica', 'bold')

            doc.text(
                currentDateTime(),
                124,
                pageHeight - 15
            );



            ///////////////////////////////////////Second part of footer

            var str = 'Page ' + pageNo;
            if (typeof doc.putTotalPages === 'function') {
                str = str + ' of ' + totalPagesExp;
            }

            doc.setTextColor('black')
            doc.setFontSize(9)
            const lineHeight = 286
            const lineWidth = 182
            const lineX = 14
            const lineY = lineHeight
            doc.line(lineX, lineY, lineX + lineWidth, lineY)
            doc.text(str, 230, 290, { align: 'right' })
            doc.text(`Printed By `, 20, 290, { align: 'left' })
            doc.setTextColor('blue')
            doc.text(`${user ? user.name : ''}`, 37, 290, { align: 'left' })

        };

        const cashFlowStatementFirstPage = () => {
            doc.autoTable({
                head: headRows(asOf, lastYearLastDate),
                body: bodyRows(cashFlowStatementData),
                theme: "plain",
                headStyles: {
                    fillColor: [255, 255, 255],
                    textColor: [60, 75, 100],
                    fontSize: 10,
                },
                columnStyles: {
                    0: { halign: 'left', cellWidth: 90, minCellHeight: 6, font: "helvetica", fontSize: 9 },  // Account Description
                    1: { halign: 'center', cellWidth: 15, minCellHeight: 6, font: "helvetica", fontStyle: 'bold', fontSize: 9 }, // Note
                    2: { halign: 'right', cellWidth: 40, minCellHeight: 6, font: "helvetica", fontSize: 9 }, // As Of Current Year
                    3: { halign: 'right', cellWidth: 40, minCellHeight: 6, font: "helvetica", fontSize: 9 }, // As Of Last Year
                },
                margin: { top: 40, bottom: 30, left: 10 },
                didDrawPage: function () {
                    header();
                    footer();
                },
                willDrawCell: function (data) {

                    if (data.row.section === 'head' && data.column.index > 1) {
                        const { doc, cell } = data;
                        const lineWidth = cell.width;
                        const lineX = cell.x + 2;
                        const lineY = cell.y + cell.height;

                        doc.setDrawColor(0, 0, 0); // Black color
                        doc.setLineWidth(1); // Set line width
                        doc.line(lineX, lineY, lineX + lineWidth - 2, lineY); // Draw the line
                    }

                    if (data.row.section === 'body' && data.row.raw[4].content === true && data.column.index > 1) {
                        const { doc, cell } = data;
                        const lineWidth = cell.width;
                        const lineX = cell.x + 2;
                        const lineYTop = cell.y; // Top position of the cell

                        doc.setDrawColor(0, 0, 0); // Black color
                        doc.setLineWidth(0.5); // Set line width

                        // Draw the top border
                        doc.line(lineX, lineYTop, lineX + lineWidth - 2, lineYTop);
                        doc.line(lineX, lineYTop + 6, lineX + lineWidth - 2, lineYTop + 6);
                    }
                },
                didParseCell: function (data) {
                    if (data.section === 'body' && data.row.raw[4].content === true && data.column.index > 1) {
                        data.cell.styles.fontSize = 10;
                        data.cell.styles.fontStyle = 'bold';
                    }
                    if (data.section === 'head') {
                        data.cell.styles.fontStyle = 'bold';
                    }
                },
            });
        };

        const cashFlowStatementPages = () => {
            // Add a new page for the second table
            doc.addPage();

            doc.autoTable({
                head: headRows(asOf, lastYearLastDate),
                body: bodyRowsNotes(cashFlowStatementData),
                theme: "plain",
                headStyles: {
                    fillColor: [255, 255, 255],
                    textColor: [60, 75, 100],
                    fontSize: 10,
                },
                columnStyles: {
                    0: { halign: 'left', cellWidth: 90, minCellHeight: 6, font: "helvetica", fontSize: 9 },  // Account Description
                    1: { halign: 'center', cellWidth: 18, minCellHeight: 6, font: "helvetica", fontStyle: 'bold', fontSize: 9 }, // Note
                    2: { halign: 'right', cellWidth: 40, minCellHeight: 6, font: "helvetica", fontSize: 9 }, // As Of Current Year
                    3: { halign: 'right', cellWidth: 40, minCellHeight: 6, font: "helvetica", fontSize: 9 }, // As Of Last Year
                },
                margin: { top: 40, bottom: 30, left: 10 },
                didDrawPage: function () {
                    headerNotes();
                    footer();
                },
                willDrawCell: function (data) {

                    if (data.row.section === 'head' && data.column.index > 1) {
                        const { doc, cell } = data;
                        const lineWidth = cell.width;
                        const lineX = cell.x + 2;
                        const lineY = cell.y + cell.height;

                        doc.setDrawColor(0, 0, 0); // Black color
                        doc.setLineWidth(1); // Set line width
                        doc.line(lineX, lineY, lineX + lineWidth - 2, lineY); // Draw the line
                    }

                    if (data.row.section === 'body' && data.row.raw[4].content === true && data.column.index > 1) {
                        const { doc, cell } = data;
                        const lineWidth = cell.width;
                        const lineX = cell.x + 2;
                        const lineYTop = cell.y; // Top position of the cell

                        doc.setDrawColor(0, 0, 0); // Black color
                        doc.setLineWidth(0.5); // Set line width

                        // Draw the top border
                        doc.line(lineX, lineYTop, lineX + lineWidth - 2, lineYTop);
                        doc.line(lineX, lineYTop + 6, lineX + lineWidth - 2, lineYTop + 6);
                    }
                },
                didParseCell: function (data) {
                    if (data.section === 'body' && data.row.raw[4].content === true) {
                        data.cell.styles.fontSize = 10.5;
                        data.cell.styles.fontStyle = 'bold';
                    }
                    if (data.section === 'head') {
                        data.cell.styles.fontStyle = 'bold';
                    }
                },
            });
        };

        cashFlowStatementFirstPage();
        cashFlowStatementPages();

        if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp);
        }

        const pdfBlob = doc.output('blob');
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, '_blank');
    };

    const headRows = (asOf, lastYearLastDate) => {
        return [
            [
                { content: "", styles: { halign: 'center', cellWidth: 90, } },
                { content: "Note ", styles: { halign: 'center', valign: "bottom", cellWidth: 15, } },
                { content: wtFormatDate(asOf, "YYYY") + "\n(Rupees)", styles: { halign: 'center', cellWidth: 40, } },
                { content: wtFormatDate(lastYearLastDate, "YYYY") + "\n(Rupees)", styles: { halign: 'center', cellWidth: 40, } },
            ]
        ];
    };

    const bodyRows = (cashFlowStatementData) => {

        //Get first level data
        const firstLevel = firstLevelData(cashFlowStatementData);

        return firstLevel.map(row => [
            { content: row.account_description, styles: { halign: 'left', fontStyle: (row.rowToBold) ? "bold" : "normal", fontSize: (row.level < 3) ? 12 : 9 } },
            { content: row.note, styles: { halign: 'center', fontStyle: "bold", fontSize: 10 } },
            { content: row.current_year_balance !== '' ? wtFormatMoney(row.current_year_balance, "", true, 2) : "", styles: { halign: 'right', fontStyle: (row.rowToBold) ? "bold" : "normal" } },
            { content: row.last_year_balance !== '' ? wtFormatMoney(row.last_year_balance, "", true, 2) : "", styles: { halign: 'right', fontStyle: (row.rowToBold) ? "bold" : "normal" } },
            { content: row.rowToUnderline, styles: { display: 'none' } }
        ]);
    };

    const bodyRowsNotes = (cashFlowStatementData) => {
        let finalData = [];

        //Get first level data
        const firstLevel = firstLevelData(cashFlowStatementData);

        for (let i = 0; i < firstLevel.length; i++) {

            //if level is 1
            if (firstLevel[i].level === 3) {

                //get second level data by passing first level object
                let secondNote = createNotesData(firstLevel[i]);

                //converting array of object to objects to push in one array
                for (let j = 0; j < secondNote.length; j++) {
                    finalData.push(secondNote[j])
                }
            }
        }

        return finalData.map(row => [
            { content: row.account_description, styles: { halign: 'left', fontStyle: (row.rowToBold) ? "bold" : "normal", fontSize: (row.rowToBold) ? 10.5 : 9 } },
            { content: row.note, styles: { halign: 'center', fontStyle: "bold", fontSize: 10 } },
            { content: row.current_year_balance !== '' ? wtFormatMoney(row.current_year_balance, "", true, 2) : "", styles: { halign: 'right', fontStyle: (row.rowToBold) ? "bold" : "normal" } },
            { content: row.last_year_balance !== '' ? wtFormatMoney(row.last_year_balance, "", true, 2) : "", styles: { halign: 'right', fontStyle: (row.rowToBold) ? "bold" : "normal" } },
            { content: row.rowToUnderline, styles: { display: 'none' } }
        ]);
    };

    const firstLevelData = (cashFlowStatementData, lastNote = { value: 0 }) => {
        let flattenedData = [];
        cashFlowStatementData.forEach(row => {
            if (row.level > 2) {
                lastNote.value++; // Increment the note using the reference to the same object
            }

            let flattenedRow = {
                account_description: (row.id === 'total' && row.parent_account_id > 0) ? "" : row.name,
                current_year_balance: (row.level <= 2 && row.id !== 'total') ? "" : row.current_year_balance,
                last_year_balance: (row.level <= 2 && row.id !== 'total') ? "" : row.last_year_balance,
                note: (row.level > 2) ? lastNote.value : "",
                rowToBold: (row.level <= 2) ? true : false,
                rowToUnderline: (row.id === 'total') ? true : false,
                level: row.level,
                children: row.children,
            };

            flattenedData.push(flattenedRow);

            if (row.children && row.children.length > 0 && row.level <= 2) {
                flattenedData = flattenedData.concat(firstLevelData(row.children, lastNote));
            }
        });
        return flattenedData;
    };


    const createNotesData = (firstLevelObject) => {
        let NotesData = [];

        let notesRow = {
            account_description: firstLevelObject.note + "  " + firstLevelObject.account_description.trim(),
            current_year_balance: "",
            last_year_balance: "",
            level: firstLevelObject.level,
            note: "",
            note_value: firstLevelObject.note,
            rowToBold: true,
            rowToUnderline: false,
        };

        NotesData.push(notesRow);

        if (firstLevelObject.children && firstLevelObject.children.length > 0) {

            let noteValue = 0;

            for (let i = 0; i < firstLevelObject.children.length; i++) {

                let notesThirdRow = {
                    account_description: "        " + firstLevelObject.children[i].name,
                    current_year_balance: firstLevelObject.children[i].current_year_balance,
                    last_year_balance: firstLevelObject.children[i].last_year_balance,
                    level: firstLevelObject.children[i].level,
                    note: firstLevelObject.note + "." + (++noteValue),
                    rowToBold: false,
                    rowToUnderline: false,
                    children: (firstLevelObject.children[i].children && firstLevelObject.children[i].children.length > 0) ? firstLevelObject.children[i].children : []
                };

                NotesData.push(notesThirdRow);
            };


            //Total Row
            let totalRow = {
                account_description: "",
                current_year_balance: firstLevelObject.current_year_balance,
                last_year_balance: firstLevelObject.last_year_balance,
                level: firstLevelObject.children[firstLevelObject.children.length - 1].level,
                note: "",
                rowToBold: true,
                rowToUnderline: true,
                children: []
            };
            NotesData.push(totalRow);

        }
        return NotesData;
    };

    generatePdf(cashFlowStatementData, asOf, lastYearLastDate);

};


export default Pdf;
